import { PropsWithChildren, ReactNode } from 'react';

interface ConfigurationBoxProps extends PropsWithChildren {
    label?: string;
    leftDescription?: ReactNode;
    rightDescription?: ReactNode;
    footer?: ReactNode;
}

export default function ConfigurationBox({
    label = 'Default label',
    leftDescription = 'Default left description',
    rightDescription,
    footer,

    children,
}: ConfigurationBoxProps) {
    return (
        <div className="w-full h-auto grid grid-cols-1 rounded-md bg-surface-1 border-[0.5px] border-line overflow-hidden">
            <div className="w-full p-4 border-b-[0.5px] border-line">
                <h2 className="text-lg font-bold">{label}</h2>
                <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center">
                    <div className="text-base text-fg/68">{leftDescription}</div>
                    <div className="mt-1 lg:mt-0 text-base text-fg/68">{rightDescription}</div>
                </div>
            </div>
            <div className="w-full h-auto p-4 flex flex-col justify-center items-center">
                {children}
            </div>

            {footer && <div className="w-full p-4 border-t-[0.5px] border-line">{footer}</div>}
        </div>
    );
}
